// extracted by mini-css-extract-plugin
module.exports = {"lds-ripple":"Ripple_lds-ripple__1iTmI"};